module.exports = __webpack_public_path__ + "img/Kloster_Orlad_2kl.72970fae.jpg";